import { Component, OnInit } from '@angular/core';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';

@Component({
  selector: 'app-sgrh-credito',
  templateUrl: './sgrh-credito.component.html',
  styleUrls: ['./sgrh-credito.component.scss'],
})
export class SgrhCreditoComponent implements OnInit {
  private readonly recurso: string = 'sgrh-credito'; //mesmo que a rota
  constructor(
    private servService: ServidorService,
    private env: EnvService,
    private service: RestService
  ) {}

  ngOnInit() {
    this.atualizar();
  }

  atualizar() {
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
  }
}
